<template>
    <section :class="{slice: true, 'slice-picture-gallery--hasBackground': slice.primary.withBackground}">
        <div :class="{'slice-content': true, 'slice-content--fullWidth': slice.primary.fullWidth}">
            <MktSliceTitle v-if="slice.primary.title?.length" :field="slice.primary.title" class="slice-picture-gallery__title" />
            <div class="picture-gallery">
                <PrismicImage :field="slice.primary.image1" />
                <div>
                    <PrismicImage :field="slice.primary.image2" />
                    <PrismicImage :field="slice.primary.image3" />
                </div>
                <PrismicImage :field="slice.primary.image4" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicImage} from '@prismicio/vue';
    import type {PictureGallerySlice} from '@prismicio-types';
    import {MktSliceTitle} from '#components';

    defineProps(getSliceComponentProps<PictureGallerySlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-content {
        &--fullWidth {
            padding: var(--joy-core-spacing-9) 0;
        }
    }

    .slice-picture-gallery {
        &--hasBackground {
            background-color: var(--joy-color-quaternary-10);
        }

        &__title {
            padding-bottom: 40px;
        }
    }

    .picture-gallery {
        display: grid;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: var(--joy-core-spacing-4);
        @include mq.screen_sm(min) {
            aspect-ratio: 72 / 37;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: var(--joy-core-spacing-6);
        }

        > div {
            position: relative;
            overflow: hidden;
            display: grid;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            gap: var(--joy-core-spacing-4);
            @include mq.screen_sm(min) {
                gap: var(--joy-core-spacing-6);
            }
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
</style>
